export const formatDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.round(seconds % 60);
    return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
  } else {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.round(seconds % 60);
    let result = `${hours}h`;
    if (minutes > 0) result += ` ${minutes}m`;
    if (remainingSeconds > 0 && hours === 0) result += ` ${remainingSeconds}s`;
    return result;
  }
};

export const formatMilliseconds = (milliseconds: number): string => {
  return `${Math.round(milliseconds).toLocaleString()}ms`;
};

export const formatTime = (timestamp: string): string => {
  return new Date(timestamp).toLocaleTimeString();
};
